import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div className="bhp-padding-4x">
    <h3> Page not found (404)</h3>
    <span>
      <Link to="/">
        <span>Go home</span>
      </Link>
    </span>
  </div>
);

export default NotFoundPage;
